import { axiosInstance } from "functions";

/*
		날짜: 2024/05/18 11:32 AM
		작성자: solitair
		http method: PATCH
		URI: /schedules
*/
export const schedulePatchApi = async (id, data, options = {}) => {
    try {
        const response = await axiosInstance.patch(`${process.env.REACT_APP_IP_ADDRESS}/schedules/${id}`, data, options);
        console.log("schedulePatchApi response: ", response.data);
        return response.data;
    } catch (error) {
        alert('Patch schedule error: '+ error.response?.data?.message);
        if (error.response && error.response.status === 401) {
            throw new Error('Unauthorized');
        }
        throw error;
    }
};

